
import CompomentLoader from '~/components/CompomentLoader'
import getPageData from '~/helpers/getPageData'

export default {
  components: { CompomentLoader },
  layout: 'article',
  head() {
    const hreflang = []

    if (this.page?.attributes?.locale === 'en') {
      hreflang.push({
        rel: 'alternate',
        hreflang: 'x-default',
        href: `https://echowave.io/${this.page.attributes.slug}/`,
      })
    }

    this.page.attributes.localizations.data.forEach((localization) => {
      if (localization?.attributes?.locale === 'en') {
        hreflang.push({
          rel: 'alternate',
          hreflang: 'x-default',
          href: `https://echowave.io/${localization.attributes.slug}/`,
        })
      }

      hreflang.push({
        rel: 'alternate',
        hreflang: localization.attributes.locale,
        href: `https://echowave.io/${localization.attributes.slug}/`,
      })
    })

    return {
      title: this.page.attributes.title,
      htmlAttrs: {
        lang: this.page.attributes.locale,
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.attributes.description ? this.page.attributes.description : '',
        },

        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:title', property: 'og:title', content: this.page.attributes.title },
        { hid: 'og:url', property: 'og:url', content: 'https://echowave.io/' + this.page.attributes.slug + '/' },
        { hid: 'og:description', property: 'og:description', content: this.page.attributes.description },
        { hid: 'og:image', property: 'og:image', content: 'https://bucket.echowave.io/file/echowave-open-graph/' + this.page.attributes.slug + '.jpg' },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: this.page.attributes.title },
        { hid: 'twitter:url', name: 'twitter:url', content: 'https://echowave.io/' + this.page.attributes.slug + '/' },
        { hid: 'twitter:description', name: 'twitter:description', content: this.page.attributes.description },
        { hid: 'twitter:image', name: 'twitter:image', content: 'https://bucket.echowave.io/file/echowave-open-graph/' + this.page.attributes.slug + '.jpg' },
      ],
      link: [
        {
          rel: 'alternate',
          hreflang: this.page.attributes.locale,
          href: `https://echowave.io/${this.page.attributes.slug}/`,
        },
        ...hreflang,
      ],
    }
  },
  async asyncData({ params, error, env, isDev }) {
    const regex = /(.+)-to-(.*)\/+$/
    const match = params.pathMatch.match(regex)

    const formats = ['3G2', '3GP', 'AAF', 'ASF', 'AV1', 'AVCHD', 'AVI', 'CAVS', 'DIVX', 'DV', 'F4V', 'FLV', 'HEVC', 'M2TS', 'M2V', 'M4V', 'MJPEG', 'MKV', 'MOD', 'MOV', 'MP4', 'MPEG', 'MPEG-2', 'MPG', 'MTS', 'MXF', 'OGV', 'RM', 'RMVB', 'SWF', 'TOD', 'TS', 'VOB', 'WEBM', 'WMV', 'WTV', 'XVID', '8SVX', 'AAC', 'AC3', 'AIFF', 'AMB', 'AMR', 'APE', 'AU', 'AVR', 'CAF', 'CDDA', 'CVS', 'CVSD', 'CVU', 'DSS', 'DTS', 'DVMS', 'FAP', 'FLAC', 'FSSD', 'GSM', 'GSRT', 'HCOM', 'HTK', 'IMA', 'IRCAM', 'M4A', 'M4R', 'MAUD', 'MP2', 'MP3', 'NIST', 'OGA', 'OGG', 'OPUS', 'PAF', 'PRC', 'PVF', 'RA', 'SD2', 'SHN', 'SLN', 'SMP', 'SND', 'SNDR', 'SNDT', 'SOU', 'SPH', 'SPX', 'TAK', 'TTA', 'TXW', 'VMS', 'VOC', 'VOX', 'VQF', 'W64', 'WAV', 'WMA', 'WV', 'WVE', 'XA']

    if (match && match.length > 2 && formats.includes(match[1]) && formats.includes(match[2])) {
      console.log(`Convert from ${match[1]} into ${match[2]}`)

      return {
        convert: {
          from: match[1],
          to: match[2],
        },
        page: {
          attributes: {
            title: `Convert ${match[1]} to ${match[2]} online (No Download Required)`,
            slug: params.pathMatch,
            description: '',
          },
        },
      }
    } else {
      const pageData = await getPageData(env, params.pathMatch, error)
      return {
        page: pageData,
      }
    }
  },
}
